module.exports = __webpack_public_path__ + "static/media/floor_w2.caa211be.png";